export const selectBrandsList = (state) => state.restaurants.brandsList;
export const selectCateringBrandsList = (state) => state.restaurants.cateringBrandsList;
export const selectCateringAreaCharges = (state) => state.restaurants.cateringAreaCharges;
export const selectCateringDeliveryCharge = (state) => state.restaurants.cateringDeliveryCharge || 0;
export const selectCateringDiscountPrice = (state) => state.restaurants.cateringDiscountPrice || 0;
export const selectBranchDetails = (state) =>
  state.restaurants.selectedBranchDetails;
export const selectItems = (state) => state.restaurants.items;
export const selectCateringItems = (state) => state.restaurants.cateringItems;
export const selectCateringCategories = (state) => state.restaurants.cateringCategories;
export const selectCateringPackages = (state) => state.restaurants.cateringPackages;
export const selectCateringPackagesTimestamp = (state) => state.restaurants.cateringPackagesTimestamp;
export const selectCateringRestaurantId = (state) => state.restaurants.cateringRestaurantId;
export const selectCategories = (state) => state.restaurants.categories;
export const selectCartItems = (state) => state.restaurants.cart.items;
export const selectCartTotal = (state) => state.restaurants.cart.total;
export const selectCartSubTotal = (state) => state.restaurants.cart.subTotal;
export const selectCartTax = (state) => state.restaurants.cart.tax;
export const selectCartId = (state) => state.restaurants.cart.cartId;
export const selectCartRestaurantDetails = (state) => state.restaurants.cart.restaurantDetails;
export const selectCartDeliveryCharges = (state) => state.restaurants.cart.deliveryCharges;
export const selectProductDetail = (state) => state.restaurants.productDetail;
export const selectShowProductDetail = (state) => state.restaurants.showProductDetail;
export const selectCartVariantItems = (state) => state.restaurants.cart.variantItems;
export const selectUnavailableItems = (state) => state.restaurants.unavailableItems;
export const selectPickupBrands = (state) => state.restaurants.pickupBrands;
export const selectEditingVariantItem = (state) => state.restaurants.editingVariantItem;

// Add selectors for processed reorder state
export const selectProcessedReorder = (state) => state.restaurants.processedReorder;
export const selectProcessedOrderId = (state) => state.restaurants.processedOrderId;

// Catering cart selectors with safe fallbacks
export const selectCateringCart = (state) => {
  const cateringCart = state.restaurants.cateringCart;
  if (!cateringCart) {
    return {
      packages: [],
      items: [],
      notes: "",
      filters: { date: "", time: "", pax: 20 },
      subtotal: 0,
      total: 0,
    };
  }
  
  // Ensure items is always an array
  return {
    ...cateringCart,
    items: Array.isArray(cateringCart.items) ? cateringCart.items : [],
    packages: Array.isArray(cateringCart.packages) ? cateringCart.packages : [],
  };
};
export const selectCateringCartPackages = (state) => {
  const packages = state.restaurants.cateringCart?.packages;
  return Array.isArray(packages) ? packages : [];
};
export const selectCateringCartItems = (state) => {
  // Aggregate items from all packages in the nested structure
  const packages = state.restaurants.cateringCart?.packages;
  if (!Array.isArray(packages)) return [];
  
  return packages.flatMap(pkg => 
    Array.isArray(pkg.items) ? pkg.items : []
  );
};
export const selectCateringCartFilters = (state) => state.restaurants.cateringCart?.filters || { date: "", time: "", pax: 20 };
export const selectCateringCartNotes = (state) => state.restaurants.cateringCart?.notes || "";
export const selectCateringCartSubtotal = (state) => state.restaurants.cateringCart?.subtotal || 0;
export const selectCateringCartTotal = (state) => state.restaurants.cateringCart?.total || 0;
export const selectCateringCheckoutCart = (state) => {
  const checkout = state.restaurants.cateringCart?.checkoutCart;
  return Array.isArray(checkout) ? checkout : [];
};
export const selectCateringCartIds = (state) => {
  const cartIds = state.restaurants.cateringCart?.cateringCartIds;
  return Array.isArray(cartIds) ? cartIds : [];
};
export const selectCateringItemsToRestore = (state) => state.restaurants.cateringCart?.itemsToRestore || null;
export const selectIsPastOrderRestoration = (state) => state.restaurants.cateringCart?.isPastOrderRestoration || false;
export const selectIsModifyOrderMode = (state) => state.restaurants.cateringCart?.isModifyOrderMode || false;
export const selectModifyOrderPax = (state) => state.restaurants.cateringCart?.modifyOrderPax || null;
export const selectModifyOrderId = (state) => state.restaurants.cateringCart?.modifyOrderId || null;
// Removed: modifyCombineOrderId - no longer needed, check is done in transformation functions
export const selectPastOrderAddressId = (state) => state.restaurants.cateringCart?.pastOrderAddressId || null;
export const selectModifyOrderOriginalTotal = (state) => state.restaurants.cateringCart?.modifyOrderOriginalTotal || null;
export const selectIsUnpaidOrderMode = (state) => {
  const value = state.restaurants.cateringCart?.isUnpaidOrderMode || false;
  console.log('📍 selectIsUnpaidOrderMode called:', {
    value,
    fullCateringCart: state.restaurants.cateringCart
  });
  return value;
};
export const selectUnpaidOrderId = (state) => {
  const value = state.restaurants.cateringCart?.unpaidOrderId || null;
  console.log('selectUnpaidOrderId:', value);
  return value;
};
export const selectUnpaidCombineOrderId = (state) => {
  const value = state.restaurants.cateringCart?.unpaidCombineOrderId || null;
  console.log('selectUnpaidCombineOrderId:', value);
  return value;
};

export const selectIsReorderMode = (state) => {
  const value = state.restaurants.cateringCart?.isReorderMode || false;
  console.log('selectIsReorderMode:', value);
  return value;
};

export const selectReorderOrderId = (state) => {
  const value = state.restaurants.cateringCart?.reorderOrderId || null;
  console.log('selectReorderOrderId:', value);
  return value;
};

export const selectReorderOriginalTotal = (state) => {
  const value = state.restaurants.cateringCart?.reorderOriginalTotal || null;
  console.log('selectReorderOriginalTotal:', value);
  return value;
};
// Removed: unpaidCombineOrderId - no longer needed, check is done in transformation functions
export const selectPendingPayment = (state) => state.restaurants.cateringCart?.pendingPayment || null;

// Additional services selectors
export const selectAdditionalServices = (state) => state.restaurants.additionalServices;
export const selectSelectedAdditionalService = (state) => state.restaurants.selectedAdditionalService;
export const selectAdditionalServiceItems = (state) => state.restaurants.additionalServiceItems;
export const selectAdditionalServiceCategories = (state) => state.restaurants.additionalServiceCategories;
export const selectCateringAdditionalServiceFilters = (state) => state.restaurants.additionalServiceFilters || { pax: 20, search: "" };
